import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Landing page after Google sign-in. If it was opened as a popup, tell the opener
 * and close. Otherwise continue into the app.
 */
const LoginSuccessPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage('loginSuccess', window.location.origin);
      window.setTimeout(() => window.close(), 200);
    } else {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return <p className="app-main">Signed in. Redirecting…</p>;
};

export default LoginSuccessPage;
